<div [formGroup]="formGroup">
  <div *ngIf="fields.fieldType !== 'hidden'" class="w-full py-2">
    <div
      class="grid grid-cols-12 gap-4 rounded-lg w-full max-w-md items-center mb-1"
    >
      <div class="col-span-3 md:col-span-6">
        <label
          class="block text-2sm font-medium text-gray-900"
          [ngClass]="{ required: fields.isRequired }"
        >
          {{ fields.displayName }}
        </label>
      </div>

      <div class="col-span-9 md:col-span-6">
        <div class="flex">
          <div
            *ngFor="let option of fields.options.staticOptions"
            class="flex items-center mr-6"
          >
            <label class="radio-option flex items-center gap-2">
              <input
                type="radio"
                class="radio cursor-pointer"
                [name]="fields.fieldName"
                [checked]="selectedOptionId === option.id"
                (change)="onRadioChange(option)"
              />

              <!-- 🔹 NORMAL OPTION (NOT OTHER) -->
              <span *ngIf="option.id !== 'other'" class="text-sm text-gray-700">
                {{ option.text }}
              </span>

              <!-- 🔹 OTHER OPTION -->
              <ng-container *ngIf="option.id === 'other'">
                <input
                  *ngIf="selectedOptionId === 'other'"
                  type="text"
                  inputmode="numeric"
                  class="form-input input w-40"
                  [placeholder]="option.placeholder || 'Enter port (1–65535)'"
                  (input)="
                    onCustomInputChange($event); $event.stopPropagation()
                  "
                  (keydown)="onKeyDown($event)"
                  (paste)="onPaste($event)"
                  maxlength="5"
                />

                <span
                  *ngIf="selectedOptionId !== 'other'"
                  class="text-sm text-gray-700"
                >
                  {{ option.text }}
                </span>
              </ng-container>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="portError" class="text-danger text-xs mt-1">
    {{ portError }}
  </div>
</div>
